import { Link } from 'react-router-dom';
import { ArrowRight, MapPin, Phone, Mail } from 'lucide-react';
import { Button } from '../ui/button';
import { EuroLeafImg, RUNGIS_IMAGE } from './constants';
import { WeatherWidget } from './WeatherWidget';
import { useLanguage } from '../../context/LanguageContext';

export const HeroSection = ({ weather, forecast, parisTime, showForecast, setShowForecast }) => {
    const { t } = useLanguage();
    return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
        <div className="absolute inset-0">
            <img src={RUNGIS_IMAGE} alt="Marché de Rungis" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
            <WeatherWidget
                weather={weather}
                forecast={forecast}
                parisTime={parisTime}
                showForecast={showForecast}
                setShowForecast={setShowForecast}
            />
            <div className="max-w-3xl">
                <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium mb-8 border border-white/20" data-testid="hero-badge">
                    <MapPin className="w-4 h-4 text-emerald-400" />
                    {t.heroLocation}
                </div>

                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.1] tracking-tight">
                    {t.heroTitle1}{' '}
                    <span className="text-emerald-400">{t.heroTitle2}</span>
                    <br />
                    {t.heroTitle3}
                </h1>

                <p className="mt-6 text-lg text-white/80 max-w-xl leading-relaxed whitespace-pre-line">
                    {t.heroDesc}
                </p>

                <div className="mt-10 flex flex-col sm:flex-row gap-4">
                    <Button asChild size="lg" className="bg-emerald-500 hover:bg-emerald-600 text-white h-14 px-8 rounded-full text-base font-semibold shadow-lg shadow-emerald-500/25 transition-all hover:shadow-emerald-500/40" data-testid="hero-cta-catalogue">
                        <Link to="/catalogue">
                            {t.heroCtaCatalogue}
                            <ArrowRight className="ml-2 w-5 h-5" />
                        </Link>
                    </Button>
                    <Button asChild variant="outline" size="lg" className="h-14 px-8 rounded-full border-2 border-white/30 text-white hover:bg-white/10 text-base font-semibold backdrop-blur-sm" data-testid="hero-cta-register">
                        <Link to="/inscription">
                            {t.heroCtaRegister}
                        </Link>
                    </Button>
                </div>

                <div className="mt-10 flex flex-wrap gap-6 text-white/60 text-sm">
                    <a href="tel:0662667639" className="flex items-center gap-2 hover:text-emerald-400 transition-colors">
                        <Phone className="w-4 h-4" /> 06 62 66 76 39
                    </a>
                    <a href="mailto:asaber@prixdeal.fr" className="flex items-center gap-2 hover:text-emerald-400 transition-colors">
                        <Mail className="w-4 h-4" /> asaber@prixdeal.fr
                    </a>
                </div>
            </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 bg-white/10 backdrop-blur-md border-t border-white/10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
                    <div className="text-center">
                        <div className="text-2xl font-bold text-white">500+</div>
                        <div className="text-white/60 text-xs mt-1">{t.clientsPro}</div>
                    </div>
                    <div className="text-center">
                        <div className="text-2xl font-bold text-white">168+</div>
                        <div className="text-white/60 text-xs mt-1">{t.produitsCatalogue}</div>
                    </div>
                    <div className="text-center">
                        <div className="text-2xl font-bold text-white">24h</div>
                        <div className="text-white/60 text-xs mt-1">{t.delaiLivraison}</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    );
};
